import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Col,
} from "reactstrap";
import CreditLogService from "../../../services/OrderingServices/CreditLogService";
import toast from "react-hot-toast";

const CreditPayModal = ({ isOpen, toggle, fetchCreditLogs, selectedItem,selectedCustomer }) => {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      paidAmount: selectedItem?.creditAmount || 0,
      remarks: "",
      isBillPayment: false, // default to true or false
    },
    validationSchema: Yup.object({
      paidAmount: Yup.number()
        .typeError("Amount must be a number")
        .positive("Amount must be positive")
        .required("Amount is required"),
      remarks: Yup.string().required("Remarks is required"),
      // isBillPayment is boolean, no validation needed
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const response = await CreditLogService.creditPay(
          selectedCustomer?.id,
          values
        );
        toast.success(response);
        resetForm();
        fetchCreditLogs();
        toggle();
      } catch (error) {
        console.error(error);
        toast.error(error?.message || "Something went wrong");
      }
    },
  });

  // Reset form when modal closes
  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Pay Amount</ModalHeader>
      <form onSubmit={formik.handleSubmit}>
        <ModalBody>
          {selectedItem ? (
            <Col lg={12} md={12}>
              <Label for="paidAmount">Amount:</Label>
              <Input
                type="number"
                id="paidAmount"
                name="paidAmount"
                placeholder="Enter paidAmount"
                value={formik.values.paidAmount}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={formik.touched.paidAmount && !!formik.errors.paidAmount}
                readOnly
              />
              {formik.touched.paidAmount && formik.errors.paidAmount && (
                <div className="text-danger">{formik.errors.paidAmount}</div>
              )}
            </Col>
          ) : (
            <Col lg={12} md={12}>
              <Label for="paidAmount">Amount:</Label>
              <Input
                type="number"
                id="paidAmount"
                name="paidAmount"
                placeholder="Enter paidAmount"
                value={formik.values.paidAmount}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={formik.touched.paidAmount && !!formik.errors.paidAmount}
              />
              {formik.touched.paidAmount && formik.errors.paidAmount && (
                <div className="text-danger">{formik.errors.paidAmount}</div>
              )}
            </Col>
          )}

          <Col lg={12} md={12} className="mt-3">
            <Label for="remarks">
              Remarks: <span className="text-danger">*</span>
            </Label>
            <Input
              type="textarea"
              rows={6}
              id="remarks"
              name="remarks"
              placeholder="Enter remarks"
              value={formik.values.remarks}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.remarks && !!formik.errors.remarks}
            />
            {formik.touched.remarks && formik.errors.remarks && (
              <div className="text-danger">{formik.errors.remarks}</div>
            )}
          </Col>
          <Col className="mt-3">
            <div className="form-switch d-flex justify-content-between mb-2 p-0 m-0">
              <label className="fw-semibold mb-3 fs-5" htmlFor="creditSwitch">
                Is Bill Payment
              </label>
              <input
                className="form-check-input"
                type="checkbox"
                id="creditSwitch"
                name="isBillPayment"
                checked={formik.values.isBillPayment}
                onChange={() =>
                  formik.setFieldValue(
                    "isBillPayment",
                    !formik.values.isBillPayment
                  )
                }
              />
            </div>
          </Col>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => {
              formik.resetForm();
              toggle();
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-success"
            disabled={!formik.isValid || formik.isSubmitting}
          >
            Pay
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default CreditPayModal;
